var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgMoney(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_5175_15495)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M10.6665 10.6667C10.6665 9.93 8.57717 9.33333 5.99984 9.33333M10.6665 10.6667C10.6665 11.4033 8.57717 12 5.99984 12C3.4225 12 1.33317 11.4033 1.33317 10.6667M10.6665 10.6667V13.958C10.6665 14.7173 8.57717 15.3333 5.99984 15.3333C3.4225 15.3333 1.33317 14.718 1.33317 13.958V10.6667M10.6665 10.6667C13.2158 10.6667 15.3332 10.0087 15.3332 9.33333V2.66666M5.99984 9.33333C3.4225 9.33333 1.33317 9.93 1.33317 10.6667M5.99984 9.33333C3.0545 9.33333 0.666504 8.67533 0.666504 8V4.66666M5.99984 3.33333C3.0545 3.33333 0.666504 3.92999 0.666504 4.66666M0.666504 4.66666C0.666504 5.40333 3.0545 6 5.99984 6C5.99984 6.67533 8.1685 7.33333 10.7178 7.33333C13.2665 7.33333 15.3332 6.67533 15.3332 6M15.3332 2.66666C15.3332 1.92999 13.2665 1.33333 10.7178 1.33333C8.1685 1.33333 6.1025 1.92999 6.1025 2.66666M15.3332 2.66666C15.3332 3.40333 13.2665 3.99999 10.7178 3.99999C8.16917 3.99999 6.1025 3.40333 6.1025 2.66666M6.1025 2.66666V9.444",
    stroke: "#C6C0FA"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_5175_15495"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 16,
    height: 16,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMoney);
export default __webpack_public_path__ + "static/media/money.7c96e3173402e4ac6b6cd503b887e482.svg";
export { ForwardRef as ReactComponent };